import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import {
  disconnectGtmSession,
  getGtmSession,
  patchGtmSessionSequence,
  saveGtmSession,
  type GtmLinkedInSequenceState,
  type GtmSessionStatus,
} from "../api/GtmApi";
import { gtmQueryKeys } from "./gtmQueryKeys";

export function useGtmSessionQuery(workspaceId: string) {
  return useQuery({
    queryKey: gtmQueryKeys.session(workspaceId),
    queryFn: () => getGtmSession(workspaceId),
    enabled: Boolean(workspaceId),
    refetchOnWindowFocus: false,
    staleTime: 15_000,
  });
}

export function useGtmSessionSaveMutation(workspaceId: string) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (body: { liAt: string; tosAcknowledged: boolean }) =>
      saveGtmSession(workspaceId, body),
    onSuccess: (status: GtmSessionStatus) => {
      queryClient.setQueryData(gtmQueryKeys.session(workspaceId), status);
    },
  });
}

export function useGtmSessionDisconnectMutation(workspaceId: string) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: () => disconnectGtmSession(workspaceId),
    onSuccess: (status: GtmSessionStatus) => {
      queryClient.setQueryData(gtmQueryKeys.session(workspaceId), status);
    },
  });
}

export function useGtmSessionSequenceMutation(workspaceId: string) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (sequence: GtmLinkedInSequenceState) =>
      patchGtmSessionSequence(workspaceId, sequence),
    onSuccess: (status: GtmSessionStatus) => {
      queryClient.setQueryData(gtmQueryKeys.session(workspaceId), status);
    },
  });
}
